var cartTotal = 0,
    gwpQualificationProduct = false,
    gwpQualificationProductQuantity = 0,
    giftProductQuantity = 0,
    gwpPresent = false,
    gwpModalClosed = false;
    gwpQualified = false;

const defaultCurrency = 'CAD',
    selectedCurrency = $('.currency-picker__label:first').text(),
    gwpContainer = '.gwp-container';


tierDiscount = false;


var gwpThreshold = 1;

function openGwp() {
    gwpModalClosed = parseInt(document.cookie.replace(/(?:(?:^|.*;\s*)gwp-stocking-stuffer-bezel-earrings-necklace-setstocking-stuffer-mini-sparkle-heart-studs-pendant-set\s*\=\s*([^;]*).*$)|^.*$/, '$1'));
    if (gwpQualified == true && !gwpPresent && !gwpModalClosed && !tierDiscount) {
        $(gwpContainer).fadeIn('fast');
        $('body').addClass('modal-open');
    }
    console.log(cartTotal);
}

function getCart() {    
    setTimeout(function () {
        jQuery.ajax({
            type    : 'GET',
            url     : '/cart.js',
            dataType: 'json',
            success : function (cart) {
                cartTotal = 0;
                $.each(cart.items, function (i, f) {
                    var handle = f.handle;

                 
                    if (f.properties) {
                        if (f.properties.Promo == giftPropertyValue) {
                            gwpPresent = true;
                            giftId     = f.key;
                            cartTotal = cartTotal - f.final_price
                        } 
                    }
                 

                  
                    if (f.discounts.length > 0) {
                      console.log("==========================");
                      console.log(f);
                      var str = f.discounts[0].title;
                        if (str.indexOf("Ornament") > -1) {
  
                                gwpPresent = true;
                                giftId     = f.key;          
                                                    
                        }
                      console.log("==========================");
                    }

                    if (f.discounts.length > 1) {
                      console.log("==========================");
                      console.log(f.discounts);
                      var str = f.discounts[1].title;
                        if (str.indexOf("gift") > -1) {
                                gwpPresent = true;
                                giftId     = f.key;  
                                                    
                        }
                      console.log("==========================");
                    }                  
                  
         
                        if (handle.indexOf("gift-card") == -1) {
                            cartTotal += f.line_price;  
                        }                     

                    if (f.handle == giftProduct && gwpQualificationType == 'collection') {
                        gwpPresent = true;
                    }

                    if (gwpQualificationType == 'collection' && f.handle == giftProduct) {
                        giftProductQuantity += f.quantity;
                    }

                    if ($.inArray(handle, qualificationProducts) !== -1 && gwpQualificationType == 'collection') {
                        gwpQualificationProduct = true;
                        gwpQualificationProductQuantity += f.quantity;
                    }
                });

              cartTotal = cartTotal / 100;
                if (gwpQualificationType == 'collection') {
                    if (cartTotal !== 0 && !gwpPresent) {
                        $('.gwp-reminder').fadeIn();
                    }
                  $('.gwp-qualified').hide();
                  $('.gwp-unqualified').hide();
                  $('.gwp-missing-item').hide();
                    switch (true) {
                        default:
                            $('.gwp-reminder').fadeIn();
                            break;
                        case (gwpQualificationProductQuantity > 0 && cartTotal > gwpThreshold):
                            $('.gwp-qualified').show();
                            gwpQualified = true;
                            break;
                        case (cartTotal < gwpThreshold):
                            $('.gwp-unqualified').show();
                            gwpQualified = false;
                            break;
                        case (gwpQualificationProductQuantity <= 0 && cartTotal > gwpThreshold):
                            $('.gwp-missing-item').show();
                            gwpQualified = false;
                            break;
                        case (giftProductQuantity > 0):
                            $('.gwp-reminder').fadeOut();
                            break;
                    }                  
                } else {                
                if (cartTotal !== 0 && !gwpPresent) {
                    $('.gwp-remainder').text(currencySymbol + (Math.round(gwpThreshold - cartTotal)));
                    $('.gwp-reminder').fadeIn();

                    if (cartTotal < gwpThreshold || gwpQualificationType == 'product') {
                        $('.gwp-qualified').hide();
                        $('.gwp-unqualified').show();
                        $('.gwp-missing-item').hide(); 
                        gwpQualified = false;
                    } else {
                        $('.gwp-qualified').show();
                        $('.gwp-unqualified').hide();
                        $('.gwp-missing-item').hide();
                        gwpQualified = true;
                    }
                } else {
                    $('.gwp-reminder').fadeOut();
                }                  
                }

                openGwp(cartTotal);

                if ((gwpPresent && cartTotal < gwpThreshold) && gwpQualificationType == 'cart_total') {
                    jQuery.ajax({
                        type    : 'POST',
                        url     : '/cart/change.js',
                        data    : 'quantity=0&id=' + giftId,
                        dataType: 'json',
                        success : function (cart) {
                            document.cookie = 'gwp=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
                            location.reload();
                        },
                        error   : function (XMLHttpRequest, textStatus) {
                            Shopify.onError(XMLHttpRequest, textStatus);
                        }
                    });
                }
                $('.gwp-progress').width(((cartTotal/gwpThreshold) * 100).toFixed(2) + '%');
                $('.gwp-remaining').text(currencySymbol + (gwpThreshold - cartTotal));
                $('.gwp-qualification').text(currencySymbol + gwpThreshold);              
            }.bind(this),
            error   : function (XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        });
    }, 2000);
}

$(window).on('load', function () {
    discountedPrice = currencySymbol + giftPrice1 * 100 / 100;
    $('.discounted-price-1').html(discountedPrice);

    discountedPrice = currencySymbol + giftPrice2 * 100 / 100;
    $('.discounted-price-2').html(discountedPrice);
    getCart();
});

$(document).on('mouseup', '.add-to-cart', function () {
    getCart();
});

$(document).on('click', '.open-gwp', function (e) {
    document.cookie = 'gwp-stocking-stuffer-bezel-earrings-necklace-setstocking-stuffer-mini-sparkle-heart-studs-pendant-set=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
    if (gwpQualificationType == 'collection') {
        gwpPresent = false;
    }
    openGwp();
    e.preventDefault();
});

$(document).on('click', gwpContainer + ' .modal__close, .gwp-background', function () {
    var today  = new Date();
    var expire = new Date();
    expire.setTime(today.getTime() + 3600000 * 24 * 14); // 14 days
    document.cookie = "gwp-stocking-stuffer-bezel-earrings-necklace-setstocking-stuffer-mini-sparkle-heart-studs-pendant-set=1; path=/; expires=" + expire.toGMTString();
    $(gwpContainer).fadeOut('fast');
    $('body').removeClass('modal-open');
});

  $(document).on('click', '.gwp-add', function (e) {
window.themeCore.CartApi.makeRequest(themeCore.CartApi.actions.ADD_TO_CART, {
   'id': $(this).siblings('.gift_id').val(),
	 'quantity': 1,
      "properties": {
        "Promo": giftPropertyValue
      }  
}).then(res => {
    $(gwpContainer).fadeOut('fast');
    $('body').removeClass('modal-open');
  setTimeout(function () {
    window.loyaltylion && window.loyaltylion.ui.refresh();
    }, 1000);
})
.catch(e => {
	// Errors handling
  console.log(JSON.stringify(e));
  console.log($(this).siblings('.gift_id').val());
});  
    e.preventDefault();
});


$(document).on('click', '.js-cart-item-remove, .header__icon--cart, .quantity', function () {
    gwpPresent = false;
    gwpQualificationProductQuantity = 0;
    getCart();
});

// GWP modal variant selection
$(document).on('click', gwpContainer + ' .variant-input', function () {
    $(this).parents('.gift-product').find('.gift-image').attr('src', $(this).find('input').data('image'));
    $(this).parents('.gift-product').find('.gift_id').val($(this).find('input').val());

    $(gwpContainer).find(gwpContainer + ' .variant-input input').attr('checked', false);
    $(this).find('input').attr('checked', true);

    if (gwpDiscountType == 'percent') {
        variantPrice    = $(this).find('input').data('price');
        discountedPrice = Math.round(Currency.convert(variantPrice, defaultCurrency, selectedCurrency) * 100) / 100;
        discountedPrice = discountedPrice * gwpPercentPrice / 100;
        $('.product__price del').html(currencySymbol + variantPrice);
        $('.discounted-price').html(currencySymbol + discountedPrice);
    }
});

